<template>
  <div class="wrap">
    <template v-if="isOpen">
      <div class="info">
        <div class="leftInfo">
          <div class="infoTitle">
            <span>送礼账号</span>
            <a :href="consumeURL" v-show="consumeURL">
              <el-button size="mini" type="danger" icon="el-icon-search" class="xcsBtn">查消费</el-button>
            </a>
          </div>
          <div class="loginInfo" v-if="!accountInfo">
            <img src="@/assets/pic/lotteryGift.png" class="loginImg" />
            <div class="tipstext" @click="showLogin">点击授权登录虎牙账号</div>
          </div>
          <div class="loginInfo" v-else>
            <div class="avatar">
              <img :src="accountInfo.avatar" />
            </div>
            <div class="accountName">{{ accountInfo.userNick }}</div>
            <div class="logout" @click="logout">退出</div>
          </div>
        </div>
        <img src="@/assets/pic/sendToIcon.png" alt="" class="sendToImg" />
        <div class="midLine"></div>
        <div class="bottomLine"></div>
        <div class="rigthInfo">
          <div class="infoTitle">
            <span>{{ room && !roomInfo ? `直播间[${room}]` : '送礼直播间' }}</span>
            <a :href="billURL" v-show="billURL" :underline="false">
              <el-button size="mini" type="danger" icon="el-icon-search" class="xcsBtn">查流水</el-button>
            </a>
          </div>
          <div class="roomInfo">
            <img src="@/assets/pic/lotteryGift_room.png" class="roomImg" v-if="!roomInfo" />
            <template v-else-if="pwList.length > 0">
              <div class="avatar">
                <img :src="sendToLpidAvatar" />
              </div>
              <div class="accountName">
                <el-select v-model="sendToLpid" placeholder="请选择" class="anchor" v-if="pwList.length > 0">
                  <el-option v-for="item in pwList" :key="item.lUid" :label="item.sNick" :value="item.lUid"> </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <div class="avatar">
                <img :src="roomInfo.avatar" />
              </div>
              <div class="accountName">{{ roomInfo.nickname }} [{{ roomInfo.room_id }}]</div>
            </template>
            <el-input v-if="!forceRoom" size="small" v-model="room" placeholder="请输入房间号" class="roomInput" @keydown.enter.native="checkRoomUrl" @blur="checkRoomUrl"></el-input>
          </div>
        </div>
      </div>
      <div class="giftInfo">
        <div class="giftTitle">绝版礼物</div>
        <div>
          <ul class="giftWrap">
            <li v-for="item in gifts" :key="item.gid" @click="selectGift(item)">
              <div
                :class="[
                  'giftItem',
                  sendGiftId === item.gid ? 'selectGift' : '',
                  accountInfo && isWhiteListUser(accountInfo.uid) ? '' : isLuckyGift(item.gid) && (roomInfo && !isWhiteListRoom(roomInfo.room_id)) ? 'gray' : ''
                ]"
              >
                <div class="giftImg">
                  <img :src="item.img" alt="" />
                </div>
                <div class="giftName">{{ item.name }}</div>
                <div class="giftName">
                  <span>{{ item.money }}</span>
                  <img src="@/assets/pic/kicon.png" class="priceIcon" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="moneyText">
        <img src="@/assets/pic/kicon.png" class="micon" />
        <span>{{ moneyInfo.gold }}</span>
        <img src="@/assets/pic/kquan.png" class="micon" />
        <span>{{ moneyInfo.goldQuan }}</span>
        <img src="@/assets/pic/sicon.png" class="micon" />
        <span>{{ moneyInfo.sliver }}</span>
        <img src="@/assets/pic/huyabi.png" class="micon" />
        <span>{{ moneyInfo.huyabi }}</span>
      </div>
      <div class="giftFooter">
        <div class="sendGift" :class="sendGiftId ? '' : 'gray2'">
          <el-input-number v-model="sendNum" :step="1" :min="1" size="large" class="giftCount"></el-input-number>

          <el-button type="warning" class="sendBtn" @click="sendGift">送出</el-button>
        </div>
        <div class="footTips">
          个别礼物可能无法在直播间中显示特效，请谨慎选择！
        </div>
        <div class="footrecom">
          <ul>
            <li>
              <a href="https://www.xiaohudi.com/" target="_blank">
                <img src="@/assets/pic/promo/promo-xhd.jpg" alt="" />
              </a>
            </li>
            <!-- <li>
            <a href="https://www.xiaocaishu.com/" target="_blank">
              <img src="@/assets/pic/promo/promo-6.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="https://www.xiaohudi.com/" target="_blank">
              <img src="@/assets/pic/promo/promo-xhd.jpg" alt="" />
            </a>
          </li> -->
          </ul>
        </div>
      </div>
      <el-dialog title="登录" :visible.sync="showLoginFlag" width="80%" class="loginDialog" :modal="false" @close="closeLogin">
        <div class="login-tabWrap">
          <el-radio-group v-model="loginTabs" class="login-tab">
            <el-radio-button label="hyLogin">账密登录</el-radio-button>
            <el-radio-button label="accountLogin">短信登录</el-radio-button>
          </el-radio-group>
        </div>
        <div v-if="loginTabs == 'hyLogin'">
          <div class="row-padding">
            <el-input v-model.trim="username" placeholder="请输入账号" tabindex="1">
              <el-button slot="prepend">
                <i class="fa-user-circle"></i>
              </el-button>
            </el-input>
          </div>
          <div class="row-padding">
            <el-input v-model.trim="password" placeholder="请输入密码" @keypress.native="passwordInputFocus" show-password tabindex="2" @keydown.enter.native="loginWithPassword">
              <el-button slot="prepend">
                <i class="fa-key" v-show="!bigChar"></i>
                <span v-show="bigChar">大写</span>
              </el-button>
            </el-input>
          </div>
          <div class="logintipsWrap">
            <i class="el-icon-warning-outline"></i>
            <span class="logintips">登录凭证仅存储在当前设备</span>
          </div>
          <div class="loginFooter">
            <el-button @click="closeLogin" class="loginFooterBtn">取消</el-button>
            <el-button type="primary" @click="loginWithPassword" :loading="accountLoginStatus" class="loginFooterBtn">登录</el-button>
          </div>
        </div>
        <div v-else>
          <div class="row-padding">
            <el-input v-model.trim="phoneNum" placeholder="请输入手机号" @input="phoneNumInput" class="input-with-select" tabindex="3">
              <el-select v-model="areaCode" slot="prepend" placeholder="请选择" style="width:90px">
                <el-option-group v-for="group in areaCodeList" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.en" :label="`+${item.code}`" :value="item.code">
                    <span style="float: left">{{ item.zh }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">+{{ item.code }}</span>
                  </el-option>
                </el-option-group>
              </el-select>
            </el-input>
          </div>
          <div class="row-padding">
            <el-input v-model.trim="vCode" placeholder="请输入验证码" class="input-with-select" ref="vCodeInput1" tabindex="4" @keydown.enter.native="loginWithPhone">
              <template slot="append">
                <el-button type="primary" @click="vCodeTime ? '' : getVCode()" :disabled="vcodeClickLoading">{{ vCodeTime ? `重新获取(${vCodeTime}s)` : '获取验证码' }}</el-button>
              </template>
            </el-input>
          </div>
          <div class="logintipsWrap">
            <i class="el-icon-warning-outline"></i>
            <span class="logintips">登录凭证仅存储在当前设备</span>
          </div>
          <div class="loginFooter">
            <el-button @click="closeLogin" class="loginFooterBtn">取消</el-button>
            <el-button type="primary" @click="loginWithPhone" :loading="accountLoginStatus" class="loginFooterBtn">登录</el-button>
          </div>
        </div>
      </el-dialog>

      <el-dialog title="感谢大哥支持！" width="80%" class="loginDialog" :modal="false" :visible.sync="showDonateFlag" @close="closeDonate">
        <div class="donate-title">软件开发不易，能打赏一下我家主播吗？</div>
        <div class="donate-subtitle">( 打赏后该弹窗不再显示 )</div>
        <div class="donate-info">
          <div class="donate-item">
            <div class="giftItem">
              <div class="giftImg">
                <img :src="donate.gift_icon_gif" alt="" />
              </div>
              <div class="giftName">{{ donate.gift_name }} x {{ donate.count || 1 }}</div>
              <div class="giftName">
                <span>{{ donate.gift_price * (donate.count || 1) * 10 }}</span>
                <img src="@/assets/pic/kicon.png" class="priceIcon" />
              </div>
            </div>
          </div>
          <div class="donate-item">
            <div class="avatar">
              <img :src="houchi.avatar" />
            </div>
            <div class="accountName">{{ houchi.nickname }} [{{ houchi.room_id }}]</div>
          </div>
          <img src="@/assets/pic/sendToIcon.png" alt="" class="sendToImg" />
        </div>
        <div class="loginFooter">
          <el-button class="loginFooterBtn" @click="closeDonate">下次一定</el-button>
          <el-button type="primary" @click="doDonate" class="loginFooterBtn">打赏一下</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="虎牙登录验证码"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="'95%'"
        :visible.sync="frameInfo.show"
        @close="closeIframe"
        v-if="frameInfo.show"
      >
        <iframe v-if="frameInfo.show" :src="frameInfo.src" height="300" width="100%"></iframe>
        <div>*验证通过以后，请关闭对话框*</div>
      </el-dialog>
    </template>
    <div class="statement" v-else>
      <h1 class="animate__animated animate__fadeInUp">绝版礼物已暂停服务</h1>
      <p class="animate__animated animate__fadeInUp animate__delay-1s" style="font-size: 18px">😭 服务器成本越来越高了😭</p>
      <p class="animate__animated animate__fadeInUp animate__delay-2s">感谢您对绝版礼物的支持</p>
      <div class="patrol">
        <a :href="billURL || 'https://www.xiaocaishu.com/web/'" class="animate__animated animate__fadeInLeft animate__delay-3s">
          <img src="@/assets/pic/logo-xiaocaishu.png" alt="" />
          <div>查询消费</div>
        </a>
        <a href="https://www.xiaohudi.com/" class="animate__animated animate__fadeInRight animate__delay-3s">
          <img src="@/assets/pic/logo-xiaohudi.png" alt="" />
          <div>智能场控</div>
        </a>
      </div>
    </div>
  </div>
</template>
<style scoped>
.patrol {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.patrol a:first-child {
  margin-right: 30px;
}
.patrol img {
  width: 150px;
  border: 1px solid #ccc;
}
.statement {
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.statement h1 {
  font-size: 30px;
  color: red;
}
.statement p {
  line-height: 3;
}
.priceIcon {
  height: 11px;
  margin-left: 3px;
  vertical-align: middle;
}
.sendToImg {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 20px;
  margin-left: -15px;
  margin-top: -30px;
  z-index: 2;
  border: 1px dotted rgba(187, 187, 187, 100);
  border-radius: 50%;
  padding: 4px;
  box-sizing: content-box;
  background: white;
}
.footrecom {
  position: relative;
  width: 100%;
}
.footrecom > ul {
  width: 300%;
  /* animation: switch 10s ease-out infinite; */
  font-size: 0;
}
@keyframes switch {
  0%,
  25% {
    margin-left: 0;
  }
  35%,
  60% {
    margin-left: -100%;
  }
  70%,
  100% {
    margin-left: -200%;
  }
}
.footrecom > ul > li {
  float: left;
  width: 33.33%;
}
.footrecom > a {
  display: block;
}
.footrecom > ul img {
  width: 100%;
}
.footTips {
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  color: rgba(255, 6, 6, 100);
}
.giftFooter {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
}
.sendGift {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
.sendBtn {
  margin-left: 10px;
}
.giftWrap {
  font-size: 0;
  overflow-x: auto;
  width: 100%;
  white-space: nowrap;
  padding-bottom: 6px;
}
.giftInfo {
  margin: 0 20px;
}
.giftTitle {
  margin: 17px 0 5px 0;
  font-size: 16px;
}
.giftWrap li {
  display: inline-block;
  box-sizing: border-box;
  overflow: hidden;
}
.giftItem {
  padding: 9px;
  border: 1px solid transparent;
  cursor: pointer;
}
.giftItem.selectGift {
  border-color: rgba(187, 187, 187, 100);
  background-color: rgba(242, 242, 242, 100);
  overflow: hidden;
  border-radius: 13px;
}
.gray {
  -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
  filter: grayscale(100%);
  display: none;
}
.gray2 {
  -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
  filter: grayscale(100%);
}
.giftImg {
  width: 55px;
  height: 53px;
  overflow: hidden;
  display: flex;
  align-content: center;
  justify-content: center;
  margin: 0 auto 8px;
}
.giftImg img {
  width: 100%;
}
.giftName {
  text-align: center;
  font-size: 12px;
}
.info {
  display: flex;
  flex: 1;
  padding-bottom: 20px;
  justify-content: center;
  padding-top: 20px;
  position: relative;
}
.leftInfo {
  width: 50%;
}
.rigthInfo {
  width: 50%;
}
.midLine {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 1px;
  border-left: 1px dotted rgba(187, 187, 187, 100);
}
.bottomLine {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 0;
  height: 1px;
  border-bottom: 1px dotted rgba(187, 187, 187, 100);
}
.donate-info {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.donate-info .avatar,
.donate-info .avatar img {
  width: 80px;
  height: 80px;
}
.donate-item {
  width: 50%;
}
.donate-info .sendToImg {
  margin-top: -10px;
  animation: arraw 1s linear infinite;
}
@keyframes arraw {
  0% {
    opacity: 0;
    transform: translate3d(-20px, 0, 0);
  }
  50% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(20px, 0, 0);
  }
}
.infoTitle {
  text-align: center;
  font-size: 14px;
}
.loginImg {
  width: 82px;
  display: block;
  margin: 32px auto 22px;
}
.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 15px auto 15px;
  overflow: hidden;
}
.avatar img {
  width: 100px;
}
.tipstext {
  width: 157px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: center;
  border: 1px solid rgba(187, 187, 187, 100);
  margin: 0 auto;
  cursor: pointer;
}
.donate-title {
  color: red;
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}
.donate-subtitle {
  text-align: center;
  padding-bottom: 10px;
  font-size: 11px;
  color: gray;
}
.roomImg {
  width: 72px;
  display: block;
  margin: 32px auto 19px;
}
.accountName {
  text-align: center;
  margin-bottom: 13px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.roomInput {
  width: 150px;
  height: 30px;
  line-height: 30px;
  display: block;
  margin: 0 auto;
}
.loginDialog {
  z-index: 2;
}
.login-tabWrap {
  text-align: center;
  margin-bottom: 26px;
}
.loginFooterBtn {
  width: 100px;
}
.logintipsWrap {
  margin: 15px auto 18px;
  text-align: center;
}
.logintips {
  margin-left: 10px;
}
.loginFooter {
  text-align: center;
}
.loginFooter .loginFooterBtn:first-child {
  margin-right: 25px;
}
.moneyText {
  display: flex;
  justify-content: center;
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  margin: 10px 0;
}
.micon {
  height: 16px;
  margin-right: 8px;
  margin-left: 6px;
}
.logout {
  width: 57px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: center;
  border: 1px solid rgba(187, 187, 187, 100);
  margin: 13px auto 0;
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 0, 0, 0.4);
}
.xcsBtn {
  padding: 3px 7px !important;
  background-color: #ff8e16;
  margin-left: 4px;
  border-radius: 12px !important;
}
</style>
<script>
import 'animate.css'
import countryOptions from '@/assets/js/countryOptions.json'
import axios from 'axios'
import GIFTS from '@/utils/juebanGifts.json'
import { userInfo, passwordLogin, cloudLogin, getOverage, sendGift, getWechatSdk, getPWlist, sendGift2 } from '@/api/index'
const LOTTERY_GIFT = [20261, 20389, 20331, 20293]
GIFTS.sort((a, b) => {
  if (a.sort === b.sort) {
    return a.gift_price - b.gift_price
  } else {
    return a.sort - b.sort
  }
})
const search = (location.search || '?')
  .substring(1)
  .split('&')
  .reduce((map, item) => {
    const [k, v] = item.split('=')
    map[k] = v
    return map
  }, {})
let messageBox
const LISTS = []
export default {
  data() {
    return {
      isOpen: false,
      showDonateFlag: false,
      user: null,
      cookie: '',
      room: search.rid || '',
      showLoginFlag: false,
      loginTabs: 'hyLogin',
      username: '',
      password: '',
      phoneNum: '',
      isDonated: true,
      areaCode: 86,
      vCode: '',
      houchi: {
        uid: 1199530991416,
        room_id: 299023,
        room_name: '希望每一天都有不同的惊喜',
        avatar: 'https://huyaimg.msstatic.com/avatar/1045/ae/567494cf6a3679956fb5e50e8a60d1_180_135.jpg?1584848565',
        nickname: 'ZKL-后池',
        cate_name: '星秀',
        level: 30
      },
      donate: {
        gift_name: '血瓶',
        gift_id: 20277,
        gift_price: 660,
        count: 1,
        gift_icon: 'https://huyaimg.msstatic.com/cdnimage/actprop/20277_1__24_1551927385.jpg',
        gift_icon_small: 'https://huyaimg.msstatic.com/cdnimage/actprop/20277_1__18_1532856740.jpg',
        gift_icon_big_web: '',
        gift_icon_large: 'https://huyaimg.msstatic.com/cdnimage/actprop/20277_1__108_1532856820.jpg',
        gift_icon_gif: 'https://huyaimg.msstatic.com/cdnimage/actprop/20277_1__gif_1532856741.gif',
        gift_icon_frames: 'https://huyaimg.msstatic.com/cdnimage/actprop/20277_1_0_prop_streamer_resource_1532856743.png',
        gift_icon_banner: 'https://huyaimg.msstatic.com/cdnimage/actprop/20277_1__45_1532948951.jpg'
      },
      isDefaultRoom: false,
      sessionData: '',
      bigChar: false,
      accountLoginStatus: false,
      frameInfo: {
        show: false,
        src: ''
      },
      forceRoom: true,
      areaCodeList: countryOptions,
      clickLoading: false,
      vcodeClickLoading: false,
      vCodeTime: 0,
      accountInfo: null,
      roomInfo: null,
      moneyInfo: {
        gold: 0,
        sliver: 0,
        goldQuan: 0,
        huyabi: 0
      },
      isInputCheckAfter: false,
      gifts: GIFTS.map((item) => ({
        img: item.gift_icon_gif,
        name: item.gift_name,
        gid: item.gift_id,
        money: item.gift_price * 10
      })),
      sendGiftId: null,
      sendNum: 1,
      checkOverage: null,
      isWeixin: navigator.userAgent.match(/MicroMessenger/i),
      checkPwInterval: null,
      delay: false, //防止陪玩列表的同时调用
      pwList: [],
      sendToLpid: '' //送礼的主播的uid，用于陪玩的列表
    }
  },
  computed: {
    consumeURL() {
      if (this.accountInfo) {
        return `https://www.xiaocaishu.com/web/personInfo?id=${this.accountInfo.uid}`
      } else {
        return ''
      }
    },
    billURL() {
      if (this.roomInfo) {
        if (this.roomInfo.cate_name === '开黑' || this.roomInfo.cate_name === '交友') {
          return `https://www.xiaocaishu.com/web/datingHallInfo?roomid=${this.roomInfo.room_id}&id=${this.roomInfo.uid}`
        } else {
          return `https://www.xiaocaishu.com/web/anchorInfo?roomid=${this.roomInfo.room_id}&id=${this.roomInfo.uid}`
        }
      } else {
        return ''
      }
    },
    sendToLpidAvatar() {
      let data = this.pwList.find((item) => item.lUid === this.sendToLpid)
      if (data) {
        return data.sAvatarUrl
      } else {
        return ''
      }
    }
  },
  watch: {
    'roomInfo.room_id': {
      handler: function(val) {
        clearInterval(this.checkPwInterval)
        if (val && (this.roomInfo.cate_name === '开黑' || this.roomInfo.cate_name === '交友')) {
          this.getPWlistFun()
          this.checkPwInterval = setInterval(() => {
            this.getPWlistFun()
          }, 30e3)
        } else {
          this.pwList = []
        }
      },
      immediate: true
    },
    'roomInfo.uid': {
      handler: function(val) {
        this.sendToLpid = val
      },
      immediate: true
    }
  },
  async created() {
    let userinfo = await userInfo()
    let code = userinfo.code
    if (code == -2050) {
      this.$router.push({
        path: '/login',
        query: {
          redirect: 'lotterygift'
        }
      })
    } else {
      this.user = userinfo.data
    }
  },
  mounted() {
    try {
      if (this.isShowAllUser(search.uid) || this.isWhiteListRoom(search.rid) || this.isWhiteListUser(search.uid) || this.isSpecUserInRoom(search.rid, search.uid)) {
        this.isOpen = true
        this.isDefaultRoom = false
        try {
          let cookie = localStorage.getItem('lckGiftCookie')
          const account = JSON.parse(cookie)
          if (this.checkUserInfo(account)) {
            this.accountInfo = account
            this.processCookie(this.accountInfo)
            this.getOverage()
            let roomInfo = localStorage.getItem('lckGiftRoomInfo')
            this.roomInfo = JSON.parse(roomInfo)
          }
        } catch (e) {
          this.accountInfo = null
        }
        if (this.isWhiteListUser(search.uid)) {
          this.forceRoom = false
        }
        if (search.rid) {
          this.room = search.rid
          this.checkRoomUrl()
        }
      }
      // let roomInfo = localStorage.getItem('lckGiftRoomInfo')
      // if (roomInfo) {
      //   this.isDefaultRoom = false
      // } else {
      //   // this.isDefaultRoom = true
      //   // roomInfo = '{"uid":1199530991416,"room_id":299023,"room_name":"希望每一天都有不同的惊喜","avatar":"https://huyaimg.msstatic.com/avatar/1045/ae/567494cf6a3679956fb5e50e8a60d1_180_135.jpg?1584848565","nickname":"ZKL-后池","cate_name":"星秀","level":30}';
      // }
      // this.roomInfo = JSON.parse(roomInfo)
      // if (this.roomInfo.room_id == '299023') {
      //   this.isOpen = true
      // }
    } catch (e) {
      this.roomInfo = null
    }
    this.weixinShare()
    this.checkOverage = setInterval(() => {
      this.getOverage()
    }, 10e3)
  },
  methods: {
    async getPWlistFun() {
      if (!this.roomInfo || this.delay) return
      this.delay = true
      setTimeout(() => {
        this.delay = false
      }, 1e3)
      let data = await getPWlist({
        roomId: this.roomInfo.room_id
      })
      this.pwList = data.data.filter((item) => item.lUid)
      this.pwList.unshift({
        iPos: 0,
        lUid: this.roomInfo.uid,
        sAvatarUrl: this.roomInfo.avatar,
        sNick: this.roomInfo.nickname
      })
      this.pwList.forEach((item) => (item.sNick = `${item.sNick}[${this.roomInfo.room_id}]`))
    },
    isLuckyGift(giftId) {
      return /^20261|20389|20331|20293$/.test(giftId)
    },
    isSpecUserInRoom(rid, uid = this.accountInfo ? this.accountInfo.uid : '') {
      return false;
      const uids = (uid + '').split(',')
      const map = {
        517237: {
          // 闪闪
          1199595899007: Date.now() < 1640878024708 ? 1 : 0
        },
        125871: {
          2316509789: 1 // 抓抓
        },
        26530244: {
          2398261024: 1 // 星星爱吃大米
        },
        436705: {
          // 王者、特特
          1836451672: 1,
          2381626055: 1
        },
        250528: {
          1665698000: 1 // 无情
        },
        264838: {
          // 糖
          1279514364630: 1, // 鹏鹏【糖糖】
          1279518913983: 1 // 无双
        },
        // 1279514364630
        17887459: {
          // 美晴家比熊【嘉彬】
          1199575244379: Date.now() < 1634137343401 ? 1 : 0
        }
      }
      for (let i = 0; i < uids.length; i++) {
        const u = uids[i]
        if (map[rid] && map[rid][u] === 1) {
          return true
        }
      }
      return false
    },
    isShowAllUser(uid = this.accountInfo && this.accountInfo.uid) {
      return false;
      // 1217634126
      const map = {
        1199588852500: 1, // 老金
        1217634126: 1,
        1630362470: 1, // 阿风
        6126377: 1, // 亚-希
        1199530991416: 1, // nxy
        1738270718: 1 // 小虎牙
      }
      return map[uid] === 1
    },
    isWhiteListRoom(rid) {
      return false;
      const rooms = {
        299023: 1, //
        281573: 1, // 美洋
        22800045: 1, // 七七
        20255: 1, // AzZ丶尤婉【255】
        219934: 1, // 锅美美
        1789570422: 1, // 白月光
        2381626055: 1, // 小卑微
        1738270718: 1, // 小虎牙
        1199581814663: 1, // atm
        2254964446: 1, // 大主播
        282236: 1 // 浩轩
      }
      if (Date.now() > 1631942913788) {
        // 浩轩的直播间只有1天的权限
        delete rooms[282236]
      }
      if (Date.now() > 1632116319030) {
        // 美美的直播间只有3天的权限
        delete rooms[219934]
      }
      if (Date.now() > 1632462203606) {
        // AzZ丶尤婉【255】的直播间只有7天的权限
        delete rooms[20255]
      }
      return rooms[rid] || this.isSpecUserInRoom(rid)
    },
    isWhiteListUser(uid = '') {
      return false;
      const uids = (uid + '').split(',')
      const map = {
        1279520372928: 1,
        1547109370: 1,
        160617325: 1,
        1199583133153: 1, // 我是一个小耙子【释槐】
        1199558690417: 1, // 只为猪牵再停留
        1199559556023: 1, // 寒天暮影
        1199573125583: 1, // 寒天暮影2, 浮生如梦【独宠灭霸】
        2254964446: 1,
        1736690706: 1,  // 华星-兮兮
        1199537856420: 1, // 我是一个小橙子【释槐】
        1279532956130: 1,
        1199516468469: 1,
        1199577830836: 1, // 学长
        1834370764: 1,
        2450883020: 1,
        16741771: 1,
        1279530260937: 1,
        1279529808260: 1,
        2450883020: 1,  // 真人哥
        2355864636: 1, // 【娅娅】的皮皮兜
        3564334: 1, // 做你的大姨妈
        6126377: 1, // 亚-希
        1199572679160: 1, // 乐事【小心酱】
        1199526941042: 1, // a哥
        1630362470: 1, // 阿风
        1789570422: 1, // 白月光
        2381626055: 1, // 小卑微
        1738270718: 1, // 小虎牙
        1199581814663: 1, // atm
        2254964446: 1, // 大主播
        1199530991416: 1, // nxy
        1199588852500: 1 // 老金，绝版礼物
      }
      for (let i = 0; i < uids.length; i++) {
        const u = uids[i]
        if (map[u] === 1) {
          console.log('>>>>', u)
          return true
        }
      }
      return false
    },
    async doDonate() {
      if (!this.accountInfo) {
        return this.$message.error('请登录虎牙号')
      }
      let ret = await sendGift({
        giftId: this.donate.gift_id,
        count: this.donate.count || 1,
        roomId: this.houchi.room_id,
        cookie: this.accountInfo.cookie
      })
      messageBox && messageBox.close()
      if (ret.msg === '扣费成功') {
        messageBox = this.$message.success('送礼成功')
        this.getOverage()
        this.showDonateFlag = false
        localStorage.setItem('donated', 1)
      } else if (ret.msg === '身份信息已过期,请重新登录') {
        if (info && info.gift_price >= 500000) {
          messageBox = this.$message.error('送出大额礼物功能正在内测中，请改天再试')
        } else {
          messageBox = this.$message.error(ret.msg)
        }
      } else if (ret.msg == '参数错误,请修正后重试') {
        messageBox = this.$message.error('登陆信息已过期，请重新登陆送礼账号')
      } else {
        messageBox = this.$message.error(ret.msg)
      }
    },
    processCookie(accountInfo = {}) {
      if (this.isShowAllUser(accountInfo.uid)) {
        this.gifts = GIFTS.filter((item) => item.gift_id != 20319).map((item) => ({
          img: item.gift_icon_gif,
          name: item.gift_name,
          gid: item.gift_id,
          money: item.gift_price * 10
        }))
      }
    },
    showLogin() {
      this.showLoginFlag = true
    },
    logout() {
      this.accountInfo = null
      this.moneyInfo = {
        gold: 0,
        sliver: 0,
        goldQuan: 0
      }
      localStorage.removeItem('lckGiftCookie')
    },
    closeDonate() {
      this.showDonateFlag = false
    },
    closeLogin() {
      this.showLoginFlag = false
      this.loginTabs = 'hyLogin'
      this.username = ''
      this.password = ''
      this.phoneNum = ''
      this.areaCode = 86
      this.vCode = ''
      this.sessionData = ''
      this.bigChar = false
      this.accountLoginStatus = false
      this.frameInfo = {
        show: false,
        src: ''
      }
      this.clickLoading = false
      this.vcodeClickLoading = false
      this.vCodeTime = 0
    },
    passwordInputFocus(event) {
      if (!window.navigator.userAgent.indexOf('MSIE') > -1) {
        // 非IE
        var e = event || window.event
        var keyvalue = e.keyCode || e.which
        var isShift = e.shiftKey || keyvalue == 16 || false
        if ((keyvalue >= 65 && keyvalue <= 90 && !isShift) || (keyvalue >= 97 && keyvalue <= 122 && isShift)) {
          this.bigChar = true
        } else {
          this.bigChar = false
        }
      }
    },
    //账密登录
    loginWithPassword() {
      if (!this.username) {
        this.$message.error('请输入账号')
        return
      }
      if (!this.password) {
        this.$message.error('请输入密码')
        return
      }
      if (this.accountLoginStatus) {
        return
      }
      this.accountLoginStatus = true
      passwordLogin(
        {
          username: this.username,
          ticket: this.user.ticket,
          password: this.password,
          agentIdx: null,
          authId: this.authId
        },
        {
          notify: false
        }
      ).then((res) => {
        this.authId = ''
        this.accountLoginStatus = false
        if (res.code == 0) {
          if (this.checkUserInfo(res.data)) {
            this.accountInfo = res.data
            this.processCookie(this.accountInfo)
            localStorage.setItem('lckGiftCookie', JSON.stringify(res.data))
            this.closeLogin()
            this.$message.success('登录成功')
            this.getOverage()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: `<strong>无效账号</strong><p style="margin-top: 5px;">请使用指定账号登陆</p>`
            })
          }
        } else {
          if (res.code === 10030 || res.code == 10039) {
            //验证码的校验
            this.frameInfo.show = true
            this.frameInfo.src = res.data.verify
            return
          }
          if (res.code == 401) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: `<strong>登录失败</strong><p style="margin-top: 5px;">${res.message}</p>`
            })
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: `<strong>登录失败，请联系客服</strong><p style="margin-top: 5px;">错误码「${res.code}」，请联系客服</p>`
            })
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`
              })
            }, 1e3)
          }
        }
      })
    },
    checkUserInfo(info) {
      const uids = ((search.uid || '') + '').split(',')
      return this.isWhiteListRoom(search.rid) || uids.indexOf(info.uid) > -1
    },
    //短信登录
    async loginWithPhone() {
      if (!this.phoneNum) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.vCode) {
        this.$message.error('请输入验证码')
        return
      }
      this.clickLoading = true
      let phoneNum = `${this.areaCode == 86 ? `0${this.areaCode}` : `00${this.areaCode}`}${this.phoneNum}`
      cloudLogin({
        phone: phoneNum,
        ticket: this.user.ticket,
        code: this.vCode,
        sessionData: this.sessionData
      }).then((res) => {
        console.log('>>>>> phone', res)
        if (res.code == 0) {
          if (this.checkUserInfo(res.data)) {
            this.accountInfo = res.data
            this.processCookie(this.accountInfo)
            localStorage.setItem('lckGiftCookie', JSON.stringify(res.data))
            this.closeLogin()
            this.$message.success('登录成功')
            this.getOverage()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: `<strong>无效账号</strong><p style="margin-top: 5px;">请使用特定账号登陆</p>`
            })
          }
        } else {
          if (res.code == 401) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: `<strong>短信登录失败</strong><p style="margin-top: 5px;">${res.message}</p>`
            })
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: `<strong>短信登录失败</strong><p style="margin-top: 5px;">请尝试其他登录方式</p>`
            })
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`
              })
            }, 1e3)
          }
        }
        this.clickLoading = false
      })
    },
    closeIframe() {
      this.frameInfo.show = false
      this.frameInfo.src = ''
      this.accountLoginStatus = false
    },
    async getVCode() {
      // this.$message.success(">>>> getVCode");
      if (!this.phoneNum) {
        this.$message.error('请输入手机号')
        return
      }
      this.vcodeClickLoading = true
      let phoneNum = `${this.areaCode == 86 ? `0${this.areaCode}` : `00${this.areaCode}`}${this.phoneNum}`
      cloudLogin({
        phone: phoneNum,
        ticket: this.user.ticket,
        agentIdx: null
      }).then((res) => {
        // this.$message.success(">>>> getVCode2," + res.code);
        if (res.code == 0) {
          this.$message.success(res.message)
          this.$refs.vCodeInput1.focus()
          this.vCodeTime = 60
          let timer = setInterval(() => {
            this.vCodeTime--
            if (this.vCodeTime <= 0) {
              clearInterval(timer)
              this.vCodeTime = 0
            }
          }, 1000)
        } else {
          // this.$message.success(">>>> getVCode3," + res.code);
          if (res.code == 400) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: '<strong>短信登录失败</strong><p style="margin-top: 5px;">请尝试其他登录方式</p>'
            })
            setTimeout(() => {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: `<strong>登录失败</strong><p style="margin-top: 5px;">您的账号可能开启了“登录保护”，请到虎牙App的「账号与安全」→「登录保护」中，关闭登录保护。</p>`
              })
            }, 1e3)
          }
        }
        this.vcodeClickLoading = false
      })
    },
    phoneNumInput(e) {
      this.phoneNum = e.replace(/[^\d]/g, '')
    },
    async checkRoomUrl() {
      if (!this.room) {
        return
      }
      if (this.isInputCheckAfter) {
        return
      }
      this.isInputCheckAfter = true
      //检查房间号是否为推流地址
      try {
        let ret = await axios.get('https://xiaocaishu.com/go/huya-res/room?room_id=' + this.room)
        if (ret && ret.status === 200 && ret.data) {
          if (ret.data.code === 0) {
            ret = ret.data.data
            this.roomInfo = ret
            this.room = ''
            localStorage.setItem('lckGiftRoomInfo', JSON.stringify(this.roomInfo))
            weixinShare()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: '<strong>找不到这个主播</strong><p style="margin-top: 5px;">请确认房间号是否正确</p>'
            })
          }
        }
      } catch (e) {}
      this.isInputCheckAfter = false
    },
    selectGift(gift) {
      this.sendGiftId = gift.gid
    },
    async sendGift() {
      if (!this.accountInfo) {
        return this.$message.error('请登录虎牙号')
      }
      if (!(this.roomInfo && this.roomInfo.room_id)) {
        return this.$message.error('请设置要送出的直播间')
      }
      if (!this.sendGiftId) {
        return this.$message.error('请点击选择礼物')
      } else if (this.isLuckyGift(this.sendGiftId)) {
        if (this.accountInfo && this.isWhiteListUser(this.accountInfo.uid)) {
          // 特殊账号
        } else if (this.roomInfo && !this.isWhiteListRoom(this.roomInfo.room_id)) {
          return this.$message.error('上上签和情书限制使用，请联系发明家主播 ZKL-后池(直播间:299023) 申请开放')
        }
      }

      let info = this.getGiftById(this.sendGiftId)
      if (this.isDefaultRoom) {
        if (!confirm(`[ZKL-后池][299023]是默认直播间，确定要给她送出礼物【${info.gift_name}】吗？`)) {
          this.isDefaultRoom = false
          return
        }
      }

      if (!this.isDonated) {
        const donated = localStorage.getItem('donated')
        if (donated == 1 || (this.roomInfo && /^299023$/.test(this.roomInfo.room_id)) || (this.accountInfo && this.isWhiteListUser(this.accountInfo.uid))) {
          this.isDonated = true
        } else {
          if (Math.random() < 0.5) {
            this.showDonateFlag = true
            return
          }
        }
      }
      let ret = ''
      if (this.roomInfo.cate_name === '开黑' || this.roomInfo.cate_name === '交友') {
        ret = await sendGift2({
          giftId: this.sendGiftId,
          count: this.sendNum,
          roomId: this.roomInfo.room_id,
          cookie: this.accountInfo.cookie,
          uid: this.sendToLpid
        })
      } else {
        ret = await sendGift({
          giftId: this.sendGiftId,
          count: this.sendNum,
          roomId: this.roomInfo.room_id,
          cookie: this.accountInfo.cookie
        })
      }

      messageBox && messageBox.close()
      if (ret.msg === '扣费成功') {
        messageBox = this.$message.success('送礼成功')
        this.getOverage()
      } else if (ret.msg === '身份信息已过期,请重新登录') {
        if (info && info.gift_price >= 500000) {
          messageBox = this.$message.error('送出大额礼物功能正在内测中，请改天再试')
        } else {
          messageBox = this.$message.error(ret.msg)
        }
      } else if (ret.msg == '参数错误,请修正后重试') {
        messageBox = this.$message.error('登陆信息已过期，请重新登陆送礼账号')
      } else {
        messageBox = this.$message.error(ret.msg)
      }
      console.log(messageBox)
    },
    async getOverage() {
      if (!this.accountInfo) {
        return
      }
      let ret = await getOverage({
        uid: this.accountInfo.uid,
        cookie: this.accountInfo.cookie
      })
      if (ret && ret.code === 200) {
        ret = ret.data
        this.moneyInfo.huyabi = this.covertNum(ret.huyabi)
        this.moneyInfo.gold = this.covertNum(ret.jindou)
        this.moneyInfo.goldQuan = this.covertNum(ret.jindouquan)
        this.moneyInfo.sliver = this.covertNum(ret.yindou)
      } else if (ret && ret.error && ret.res) {
        let text = ret.res.body
        if (text.indexOf('401') !== -1 && text.indexOf('请先登录') !== -1) {
          this.$message.error('场控账号已过期,请重新登录')
          this.moneyInfo = {
            gold: 0,
            sliver: 0,
            goldQuan: 0,
            huyabi: 0
          }
          this.accountInfo = null
          localStorage.removeItem('lckGiftCookie')
        }
      }
    },
    covertNum(num) {
      num = parseInt(num)
      if (isNaN(num)) {
        return num
      }
      if (num > 100000000) {
        num = num / 10000000
        num = num.toFixed(2)
        num += '亿'
      } else if (num > 10000) {
        num = num / 10000
        num = num.toFixed(2)
        num += '万'
      }
      return num
    },
    weixinShare() {
      if (this.isWeixin) {
        getWechatSdk(
          {
            url: location.href
          },
          { notify: false }
        ).then((res) => {
          let data = res.data
          wx.config({
            debug: data.debug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: data.jsApiList.concat(['updateAppMessageShareData', 'updateTimelineShareData'])
          })
          const shaContent = {
            title: this.roomInfo && this.roomInfo.nickname ? `${this.roomInfo.nickname}的绝版礼物` : '虎牙绝版礼物赠送', // 分享标题
            desc: this.roomInfo && this.roomInfo.nickname ? `赠送给${this.roomInfo.nickname}与众不同的绝版礼物` : '虎牙绝版礼物,尽在这里.轻松点击,赠送给你喜欢的主播', // 分享描述
            link: location.href,
            imgUrl: 'https://huyaimg.msstatic.com/cdnimage/actprop/20429_1__gif_1601473076.gif', // 分享图标
            success: function() {
              this.$message.success('设置分享朋友成功')
            }
          }
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.ready(function() {
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData(shaContent)
            wx.updateTimelineShareData(shaContent)
          })
        })
      }
    },
    getGiftById(gid) {
      return GIFTS.find((item) => item.gift_id == gid)
    }
  },
  beforeDestroy() {
    clearInterval(this.checkOverage)
    clearInterval(this.checkPwInterval)
  }
}
</script>
